<template>
    <div class="patents-container">
      <div class="title-section">
        <div class="title">
          <span>发表专利</span>
        </div>
        <div class="title-line"></div>
        <div class="title-subtitle">Patents</div>
      </div>

      <div class="list-container" v-loading="loading" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.95)">
        <div
          class="patent-card"
          v-for="(item, index) in patentList"
          :key="index"
          :style="{ animationDelay: index * 0.08 + 's' }"
        >
          <div class="card-content">
            <div class="card-header">
              <div class="card-badge">{{ item.patentTypeName }}</div>
              <div class="card-number">{{ item.applyNumber }}</div>
            </div>
            <h3 class="card-title">{{ item.title }}</h3>
            <div class="card-info">
              <div class="info-row">
                <span class="info-label">
                  <i class="el-icon-globe"></i> 公开国别
                </span>
                <span class="info-value">{{ item.publicCountryKindName }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">
                  <i class="el-icon-building"></i> 申请单位
                </span>
                <span class="info-value">{{ item.applyUnit }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">
                  <i class="el-icon-user"></i> 发明人
                </span>
                <span class="info-value">{{ item.inventor }}</span>
              </div>
            </div>
            <!-- <div class="card-action">
              <button class="action-btn" @click="routerTo('/detail', item)">
                <i class="el-icon-file-text"></i> 查看详情
              </button>
            </div> -->
          </div>

          <div class="card-footer">
            <div class="card-index">#{{ index + 1 }}</div>
            <div class="card-decoration"></div>
          </div>
        </div>

        <div v-if="!loading && patentList.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="el-icon-folder-opened"></i>
          </div>
          <p class="empty-text">No patents found</p>
          <p class="empty-hint">No patent records available</p>
        </div>
      </div>
    </div>
  </template>

<script>
import {listPatent} from '@/api/api'

export default {
  data () {
    return {
      patentList: [],
      loading: true
    }
  },
  created () {
    this.listPatent()
  },
  methods: {
    routerTo (path, row) {
      sessionStorage.detail = JSON.stringify(row)
      this.$router.push({ path })
    },
    listPatent () {
      this.loading = true
      let data = {
        pageSize: 99999,
        currPage: 1
      }
      listPatent(data).then(res => {
        if (res.code === 200) {
          this.patentList = res.data
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.patents-container {
  min-height: 600px;
}

.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.list-container {
  margin-top: 24px;
}

.patent-card {
  position: relative;
  margin-bottom: 20px;
  opacity: 0;
  animation: cardSlideIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateX(-50px) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}

.card-content {
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(47, 79, 79, 0.06);
  border: 1px solid rgba(47, 79, 79, 0.08);
  transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.patent-card:hover .card-content {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(47, 79, 79, 0.12);
  border-color: rgba(47, 79, 79, 0.15);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.card-badge {
  display: inline-block;
  padding: 5px 14px;
  background: linear-gradient(135deg, rgba(47, 79, 79, 0.1) 0%, rgba(47, 79, 79, 0.05) 100%);
  color: #2f4f4f;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  animation: badgePop 0.3s ease 0.3s forwards;
  opacity: 0;
}

@keyframes badgePop {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.card-number {
  font-size: 12px;
  color: #888;
  font-family: monospace;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #2f4f4f;
  line-height: 1.5;
  margin: 0 0 20px;
  transition: color 0.3s ease;
}

.patent-card:hover .card-title {
  color: #3d5a5a;
}

.card-info {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.info-label {
  color: #888;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}

.info-label i {
  font-size: 12px;
}

.info-value {
  color: #2f4f4f;
  font-weight: 500;
}

.card-action {
  display: flex;
  justify-content: flex-end;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 20px;
  background: rgba(47, 79, 79, 0.05);
  color: #2f4f4f;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: #2f4f4f;
  color: #fff;
  transform: translateX(5px);
}

.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 0;
  margin-top: -8px;
}

.card-index {
  font-size: 12px;
  color: #aaa;
  font-weight: 500;
}

.card-decoration {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(47, 79, 79, 0.1) 0%, rgba(47, 79, 79, 0.02) 100%);
  margin-left: 16px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  animation: emptyFadeIn 0.6s ease forwards;
}

@keyframes emptyFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.empty-icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f0f0f0 0%, #e0e0e0 100%);
  border-radius: 50%;
  margin-bottom: 24px;
}

.empty-icon i {
  font-size: 48px;
  color: #aaa;
}

.empty-text {
  font-size: 18px;
  color: #666;
  margin: 0 0 8px;
}

.empty-hint {
  font-size: 14px;
  color: #999;
  margin: 0;
}
</style>
